import type { AnimationConfig } from '../types';

// Generate short hash from config for identification
export const generateConfigHash = (config: AnimationConfig): string => {
  const str = JSON.stringify(config);
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  // Convert to positive and take first 6 characters
  const positive = Math.abs(hash).toString(36);
  return positive.substring(0, 6).toUpperCase();
};

// Compare two configs and return changed fields
export const getConfigChanges = (original: AnimationConfig, current: AnimationConfig): string[] => {
  const changes: string[] = [];
  const allKeys = new Set([...Object.keys(original), ...Object.keys(current)]);
  
  for (const key of allKeys) {
    const origVal = original[key as keyof AnimationConfig];
    const currVal = current[key as keyof AnimationConfig];
    if (JSON.stringify(origVal) !== JSON.stringify(currVal)) {
      changes.push(key);
    }
  }
  
  return changes;
};